import sliceCreator from '../../index.jsx';
import {CREATE_USER} from '../../../constants/index.jsx';
const _createUserAction = sliceCreator('CREATE_USER', CREATE_USER, 'post');

const { asyncAction: createUserAction, reducer, clearData: clearCreateUserAction } = _createUserAction;

export default reducer;

export {
    createUserAction,
    clearCreateUserAction
}